// import React from 'react';
// import { PageTitle, Card } from '../components/common';
// import { mockCohorts } from '../mockData';

// const DurationIcon = () => <svg className="w-5 h-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>;
// const CheckmarkIcon = () => <svg className="w-6 h-6 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" /></svg>;

// const MySchedulePage: React.FC = () => {
//     // Assuming the user is in the first (and only) mock cohort
//     const cohort = mockCohorts[0];

//     if (!cohort) {
//         return <PageTitle title="My Schedule" subtitle="No schedule information available." />
//     }
    
//     const { 
//         title: cohortTitle, 
//         description: cohortDescription, 
//         progress, 
//         mentor, 
//         duration, 
//         syllabus, 
//         importantDates 
//     } = cohort;

//     return (
//         <div>
//             <PageTitle title="My Schedule" subtitle="Your academic and project timeline" />

//             <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
//                 {/* Left Column */}
//                 <div className="lg:col-span-1 space-y-8">
//                     {/* Cohort Details Card */}
//                     <Card className="p-6">
//                         <h3 className="text-xl font-bold text-gray-900">{cohortTitle}</h3>
//                         <p className="text-sm text-gray-600 mt-2">
//                             {cohortDescription}
//                         </p>
                        
//                         <div className="mt-4">
//                             <div className="flex justify-between items-center text-sm font-medium text-gray-600">
//                                 <span>Progress</span>
//                                 <span>{progress}%</span>
//                             </div>
//                             <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
//                                 <div className="bg-gradient-to-r from-red-500 to-yellow-400 h-2 rounded-full" style={{ width: `${progress}%` }}></div>
//                             </div>
//                         </div>

//                         <div className="mt-6 border-t border-gray-200 pt-4 space-y-4">
//                             <div className="flex items-center gap-3">
//                                 <img src={mentor.avatar} alt={mentor.name} className="w-10 h-10 rounded-full" />
//                                 <div>
//                                     <p className="text-sm text-gray-500">Mentor</p>
//                                     <p className="font-semibold text-gray-800">{mentor.name}</p>
//                                 </div>
//                             </div>
//                             <div className="flex items-center gap-3">
//                                 <DurationIcon />
//                                 <div>
//                                     <p className="text-sm text-gray-500">Duration</p>
//                                     <p className="font-semibold text-gray-800">{duration}</p>
//                                 </div>
//                             </div>
//                         </div>
//                     </Card>

//                     {/* Important Dates */}
//                     <div>
//                         <h3 className="text-2xl font-bold text-gray-900 mb-4">Important Dates</h3>
//                         <div className="space-y-4">
//                             {importantDates.map((date, index) => (
//                                 <Card key={index} className="p-4 flex gap-4 items-center relative overflow-hidden bg-red-50/50 border border-red-200/60">
//                                     <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-red-500 to-yellow-400 rounded-l-2xl"></div>
//                                     <div className="flex-shrink-0 bg-primary text-white rounded-lg p-3 text-center w-16">
//                                         <p className="font-bold text-2xl leading-none">{date.day}</p>
//                                         <p className="text-xs font-semibold mt-1">{date.month}</p>
//                                     </div>
//                                     <div>
//                                         <h4 className="font-bold text-gray-800">{date.title}</h4>
//                                         <p className="text-sm text-gray-600 mt-1">{date.description}</p>
//                                     </div>
//                                 </Card>
//                             ))}
//                         </div>
//                     </div>
//                 </div>

//                 {/* Right Column */}
//                 <div className="lg:col-span-2">
//                     <h3 className="text-2xl font-bold text-gray-900 mb-4">Syllabus</h3>
//                     <Card>
//                         <ul className="divide-y divide-gray-200">
//                             {syllabus.map((item, index) => (
//                                 <li key={index} className="p-4 flex justify-between items-center">
//                                     <div className="flex items-center gap-4">
//                                         <CheckmarkIcon />
//                                         <div>
//                                             <p className="font-semibold text-gray-800">{item.title}</p>
//                                             <p className="text-sm text-gray-500">Duration: {item.duration}</p>
//                                         </div>
//                                     </div>
//                                     {item.completed && (
//                                         <span className="text-xs font-medium bg-green-100 text-green-700 px-3 py-1 rounded-full">
//                                             Completed
//                                         </span>
//                                     )}
//                                 </li>
//                             ))}
//                         </ul>
//                     </Card>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default MySchedulePage;


import React, { useState, useEffect } from 'react';
import { PageTitle, Card } from '../components/common';
import { getTraineeBatchDetails } from '../services/api';
import { useToast } from '../components/Toaster';

// Define types based on your API response
interface CalendarDate {
  id: number;
  title: string;
  description: string;
  eventDate: string;
}

interface Lesson {
  title: string;
  content: string[];
}

interface CurriculumItem {
  module: string;
  lessons: Lesson[];
}

interface Syllabus {
  title: string;
  duration: string;
  curriculum: CurriculumItem[];
}

interface Batch {
  batchToken: string;
  batchName: string;
  courseName: string;
  courseDescription: string;
  mentorName: string;
  startDate: string;
  endDate: string;
  numberOfCandidates: number;
  remarks: string;
  syllabus: Syllabus;
  calendarDates: CalendarDate[];
}

interface Trainee {
  TraineeToken: string;
  fullName: string;
  email: string;
}

interface BatchDetailsResponse {
  trainee: Trainee;
  batches: Batch[];
}

// Icons
const DurationIcon = () => <svg className="w-5 h-5 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" /></svg>;
const LoadingSpinner = () => <svg className="animate-spin h-5 w-5 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>;

// Expand/Collapse Icon
const ChevronDownIcon: React.FC<{ className?: string }> = ({ className = "" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={`w-5 h-5 transition-transform ${className}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);

const MySchedulePage: React.FC = () => {
  const [batchDetails, setBatchDetails] = useState<BatchDetailsResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [expandedModules, setExpandedModules] = useState<Set<number>>(new Set());
  const toast = useToast();

  // Helper function to get trainee token
  const getTraineeToken = (): string => {
    const token = localStorage.getItem('TraineeToken') || '';
    return token;
  };

  // Toggle module expansion
  const toggleModule = (index: number) => {
    setExpandedModules(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };

  // Format date to display day and month
  const formatDate = (dateString: string) => {
    try {
      const date = new Date(dateString);
      const adjustedDate = new Date(date.getTime() + date.getTimezoneOffset() * 60000);
      return {
        day: adjustedDate.getDate().toString(),
        month: adjustedDate.toLocaleString('default', { month: 'short' }),
        fullDate: adjustedDate.toLocaleDateString('en-US', { 
          year: 'numeric', 
          month: 'long', 
          day: 'numeric' 
        })
      };
    } catch (error) {
      return {
        day: '?',
        month: '???',
        fullDate: 'Invalid Date'
      };
    }
  };

  // Calculate progress based on current date between start and end dates
  const calculateProgress = (startDate: string, endDate: string): number => {
    try {
      const start = new Date(startDate).getTime();
      const end = new Date(endDate).getTime();
      const now = new Date().getTime();
      
      if (now <= start) return 0;
      if (now >= end) return 100;
      
      const totalDuration = end - start;
      const elapsed = now - start;
      return Math.min(100, Math.max(0, Math.round((elapsed / totalDuration) * 100)));
    } catch (error) {
      return 0;
    }
  };

  // Calculate duration in a readable format
  const calculateDuration = (startDate: string, endDate: string): string => {
    try {
      const start = new Date(startDate);
      const end = new Date(endDate);
      const diffTime = Math.abs(end.getTime() - start.getTime());
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const diffMonths = Math.round(diffDays / 30);
      
      if (diffMonths > 0) {
        return `${diffMonths} month${diffMonths > 1 ? 's' : ''}`;
      }
      return `${diffDays} day${diffDays > 1 ? 's' : ''}`;
    } catch (error) {
      return 'Unknown duration';
    }
  };

  // Fetch batch details from API
  const fetchBatchDetails = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const TraineeToken = getTraineeToken();
      if (!TraineeToken) {
        throw new Error('Trainee token not found. Please log in again.');
      }

      const response = await getTraineeBatchDetails(TraineeToken);
      
      if (response && response.batches) {
        setBatchDetails(response);
        // Expand first module by default
        setExpandedModules(new Set([0]));
      } else {
        throw new Error('Invalid response format from server');
      }
      
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || err.message || 'Failed to fetch batch details';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBatchDetails();
  }, []);

  if (isLoading) {
    return (
      <div>
        <PageTitle title="My Schedule" subtitle="Loading your schedule..." />
        <Card className="p-8 text-center">
          <div className="flex items-center justify-center gap-3">
            <LoadingSpinner />
            <span className="text-gray-600">Loading your schedule...</span>
          </div>
        </Card>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <PageTitle title="My Schedule" />
        <Card className="p-8 text-center">
          <h3 className="text-xl font-semibold text-red-600">Error Loading Schedule</h3>
          <p className="text-gray-500 mt-2">{error}</p>
          <button 
            onClick={fetchBatchDetails}
            className="mt-4 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors"
          >
            Try Again
          </button>
        </Card>
      </div>
    );
  }

  if (!batchDetails || !batchDetails.batches || batchDetails.batches.length === 0) {
    return (
      <div>
        <PageTitle title="My Schedule" />
        <Card className="p-8 text-center">
          <h3 className="text-xl font-semibold">No Batch Found</h3>
          <p className="text-gray-500 mt-2">You are not enrolled in any batch yet.</p>
          <button 
            onClick={fetchBatchDetails}
            className="mt-4 px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark transition-colors"
          >
            Refresh
          </button>
        </Card>
      </div>
    );
  }

  // Assuming the first batch for display
  const batch = batchDetails.batches[0];
  const progress = calculateProgress(batch.startDate, batch.endDate);
  const duration = calculateDuration(batch.startDate, batch.endDate);

  // Transform calendar dates for display
  const importantDates = batch.calendarDates?.map((calendarDate: CalendarDate) => {
    const formattedDate = formatDate(calendarDate.eventDate);
    return {
      id: calendarDate.id,
      day: formattedDate.day,
      month: formattedDate.month,
      title: calendarDate.title,
      description: calendarDate.description,
      fullDate: formattedDate.fullDate
    };
  }) || [];

  return (
    <div>
      <PageTitle 
        title="My Schedule" 
        subtitle={`${batch.courseName} - ${batch.batchName}`} 
      />

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Left Column */}
        <div className="lg:col-span-1 space-y-8">
          {/* Batch Details Card */}
          <Card className="p-6">
            <h3 className="text-xl font-bold text-gray-900">{batch.courseName}</h3>
            <p className="text-sm text-gray-600 mt-2">
              {batch.courseDescription}
            </p>
            
            {/* <div className="mt-4">
              <div className="flex justify-between items-center text-sm font-medium text-gray-600">
                <span>Progress</span>
                <span>{progress}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                <div 
                  className="bg-gradient-to-r from-red-500 to-yellow-400 h-2 rounded-full transition-all duration-300" 
                  style={{ width: `${progress}%` }}
                ></div>
              </div>
            </div> */}

            <div className="mt-6 border-t border-gray-200 pt-4 space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-primary text-white rounded-full flex items-center justify-center font-semibold">
                  {batch.mentorName?.split(' ').map((n: string) => n[0]).join('').toUpperCase() || 'M'}
                </div>
                <div>
                  <p className="text-sm text-gray-500">Mentor</p>
                  <p className="font-semibold text-gray-800">{batch.mentorName || 'Not assigned'}</p>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <DurationIcon />
                <div>
                  <p className="text-sm text-gray-500">Duration</p>
                  <p className="font-semibold text-gray-800">{duration}</p>
                </div>
              </div>
              <div className="text-sm text-gray-600">
                <div className="flex justify-between">
                  <span>Start Date:</span>
                  <span className="font-medium">{formatDate(batch.startDate).fullDate}</span>
                </div>
                <div className="flex justify-between mt-1">
                  <span>End Date:</span>
                  <span className="font-medium">{formatDate(batch.endDate).fullDate}</span>
                </div>
              </div>
              {/* <div className="text-sm text-gray-600">
                <div className="flex justify-between">
                  <span>Batch Size:</span>
                  <span className="font-medium">{batch.numberOfCandidates} candidates</span>
                </div>
              </div> */}
            </div>
          </Card>

          {/* Important Dates */}
          {importantDates.length > 0 && (
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Important Dates</h3>
              <div className="space-y-4">
                {importantDates.map((date) => (
                  <Card key={date.id} className="p-4 flex gap-4 items-center relative overflow-hidden bg-red-50/50 border border-red-200/60">
                    <div className="absolute left-0 top-0 bottom-0 w-1.5 bg-gradient-to-b from-red-500 to-yellow-400 rounded-l-2xl"></div>
                    <div className="flex-shrink-0 bg-primary text-white rounded-lg p-3 text-center w-16">
                      <p className="font-bold text-2xl leading-none">{date.day}</p>
                      <p className="text-xs font-semibold mt-1">{date.month}</p>
                    </div>
                    <div className="flex-1">
                      <h4 className="font-bold text-gray-800">{date.title}</h4>
                      <p className="text-sm text-gray-600 mt-1">{date.description}</p>
                      <p className="text-xs text-gray-500 mt-1">{date.fullDate}</p>
                    </div>
                  </Card>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* Right Column - Syllabus */}
        <div className="lg:col-span-2">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">Syllabus</h3>
          
          {batch.syllabus?.curriculum && batch.syllabus.curriculum.length > 0 ? (
            <div className="space-y-4">
              {batch.syllabus.curriculum.map((module: CurriculumItem, index: number) => (
                <Card key={index} className="overflow-hidden">
                  {/* Module Header - Clickable */}
                  <button
                    onClick={() => toggleModule(index)}
                    className="w-full p-6 text-left flex justify-between items-center hover:bg-gray-50 transition-colors"
                  >
                    <div className="flex-1">
                      <h4 className="text-lg font-bold text-gray-900">{module.module}</h4>
                      <p className="text-sm text-gray-500 mt-1">
                        {module.lessons?.length || 0} lesson{module.lessons?.length !== 1 ? 's' : ''}
                      </p>
                    </div>
                    <ChevronDownIcon 
                      className={`transform transition-transform ${
                        expandedModules.has(index) ? 'rotate-180' : ''
                      }`} 
                    />
                  </button>

                  {/* Module Content - Expandable */}
                  {expandedModules.has(index) && (
                    <div className="border-t border-gray-200">
                      <div className="p-6 space-y-6">
                        {module.lessons?.map((lesson: Lesson, lessonIndex: number) => (
                          <div key={lessonIndex} className="bg-gray-50 rounded-lg p-4">
                            <h5 className="font-semibold text-gray-800 mb-3">{lesson.title}</h5>
                            {lesson.content && lesson.content.length > 0 && (
                              <ul className="space-y-2">
                                {lesson.content.map((content: string, contentIndex: number) => (
                                  <li key={contentIndex} className="flex items-start gap-3 text-sm text-gray-600">
                                    <span className="flex-shrink-0 w-1.5 h-1.5 bg-primary rounded-full mt-2"></span>
                                    <span>{content}</span>
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </Card>
              ))}
            </div>
          ) : (
            <Card className="p-8 text-center">
              <p className="text-gray-500">No syllabus information available.</p>
            </Card>
          )}
        </div>
      </div>
    </div>
  );
};

export default MySchedulePage;